module.exports = __webpack_public_path__ + "media/images/driving_school/error_series-02032a278f8b76c12379855f6ea0462a.png";